import React, { useEffect, useMemo } from "react";
import { usePage } from "@inertiajs/inertia-react";
import { LabeledInput } from "@/Components/Form";
import { focusAtom } from "jotai-optics";
import { createQuestionAtom } from "@/Stores";
import { useAtom } from "jotai";
import { RESET } from "jotai/utils";

export function InputTypeFreeTextForm({ atom }) {
  const errors = usePage().props?.errors || {};

  const inputAtom = useMemo(
    () => focusAtom(atom, (optic) => optic.prop("inputs").at(0)),
    [atom],
  );

  const [basePayload] = useAtom(atom);
  const [payload, setPayload] = useAtom(inputAtom);

  const errorBag = basePayload.errorBag;

  const handleFormUpdate = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="flex w-full flex-col items-start">
      {!basePayload?.id && (
        <p className="mb-4">
          Free text allows you to get free text answers. You can if you want add
          an emission factor which will give all reports the same emission.
        </p>
      )}

      <div className="w-full">
        <LabeledInput
          name="label"
          title="What's your question?*"
          placeholder="Describe what kind of input you want"
          className="mb-4"
          value={payload?.label || ""}
          onChange={handleFormUpdate}
          error={errors?.[errorBag]?.[`inputs.0.label`]}
        />
      </div>
    </div>
  );
}
